<template>
    <div
        style="text-align: center"
        v-if="value != null"
    >
        <span
            v-if="value"
            class="px-3 grid-cell-success me-5"
        >
            <IconComp
                icon="fa-signal-stream"
                class="me-1 pt-1"
            ></IconComp>
        </span>
        <span
            v-else
            class="px-3 grid-cell-error me-5"
        >
            <IconComp icon="fa-signal-stream-slash"></IconComp>
        </span>
    </div>
</template>

<script setup lang="ts">
import { IconComp } from '@/components';

defineProps<{
    value: boolean | null;
}>();
</script>
